<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-12 col-sm-12 mb-3">
        <div class="card p-4">
          <div class="media">
            <div class="avatar-sm mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-light
                  text-primary
                  border-primary
                  font-size-22
                "
              >
                <i class="bx bx-world bx-md"></i>
              </span>
            </div>
            <div class="media-body">
              <h5 class="mt-3">{{ $t("website.website-web-service") }}</h5>
            </div>
          </div>
          <div class="row mt-5 mb-3">
            <div class="col-sm-12 text-right">
              <div class="input-group">
                <input
                  id="search"
                  type="text"
                  class="form-control"
                  v-model="searchKey"
                  placeholder="domainname.com"
                  v-on:input="removeHttp(searchKey)"
                  aria-describedby="search"
                  @keyup.enter="searchWebsite"
                />
                <div class="input-group-prepend">
                  <button
                    id="search"
                    class="input-group-text bg-primary text-white"
                    @click="searchWebsite"
                  >
                    <i class="bx bx-search-alt search-icon"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="loading" class="row mt-5 mb-5 pb-4 mx-auto">
            <div class="text-center">
              <div
                class="spinner-border text-secondary"
                role="status"
                v-if="loading"
              >
                <span class="sr-only"
                  ><p>{{ $t("website.website-location") }}</p></span
                >
              </div>
            </div>
          </div>
          <div
            v-if="error !== '' && !loading"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ error }}</span>
            </div>
          </div>
          <div
            v-if="!SearchResult[0] && !loading && search && error == ''"
            class="row mt-5 mb-5 pb-4 mx-auto"
          >
            <div class="text-center">
              <span class="text-secondary">{{ $t("all.dnf") }}</span>
            </div>
          </div>
          <div>
            <div class="row mt-0 mx-3" v-if="SearchResult[0]">
              <table class="table px-4">
                <thead>
                  <tr>
                    <td>
                      <b>{{ $t("website.name") }} </b>
                    </td>
                    <td>
                      <b>Port </b>
                    </td>
                    <td>
                      <b>Status </b>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="service in SearchResult"
                    :key="service.id_web_service"
                  >
                    <td>
                      {{ service.name }}
                    </td>
                    <td>
                      {{ service.port }}
                    </td>
                    <td>
                      <span
                        v-if="service.status == 'Open'"
                        class="text-success"
                      >
                        {{ service.status }}
                      </span>
                      <span
                        v-if="service.status == 'Close'"
                        class="text-danger"
                      >
                        {{ service.status }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>

              <div class="col-sm-12 text-right" v-if="SearchResult">
                <b-button
                  class="btn"
                  variant="secondary"
                  size="sm"
                  @click="clearData"
                  ><i class="fa fa-times"></i>
                  {{ $t("website.clear") }}</b-button
                >
                <b-button
                  class="btn"
                  variant="success"
                  size="sm"
                  @click="saveWebService"
                  ><i class="fa fa-check"></i>
                  {{ $t("website.save") }}</b-button
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-5">
      <div class="col-sm-6">
        <h5>{{ $t("website.list_web_service") }}</h5>
      </div>
      <div class="col-sm-6 text-right"></div>
    </div>

    <div class="row mt-2 mb-4">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.show") }}&nbsp;&nbsp;
                    <b-form-select
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                      class="mx-0"
                    ></b-form-select
                    >&nbsp;&nbsp;
                  </label>
                  {{ $t("all.entries") }}
                  <b-button
                    class="btn btn-sm ml-3"
                    variant="danger"
                    @click="bulkAction()"
                    v-if="selected[0]"
                  >
                    {{ $t("button.bulk") }} : {{ selected.length }}
                    {{ $t("button.row-data") }}</b-button
                  >
                </div>
              </div>

              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-right"
                >
                  <label class="d-inline-flex align-items-center">
                    {{ $t("all.search") }}:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      :placeholder="$t('all.searchh')"
                      class="form-control form-control ml-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive mb-0">
              <b-table
                :items="tableData"
                :fields="fields"
                striped
                bordered
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
              >
                <template #head(bulk) width="4%">
                  <b-form-checkbox
                    v-model="selectAll"
                    @change="select"
                    class="text-center mt-0"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(bulk)="row" width="4%">
                  <b-form-checkbox
                    class="text-center mt-0"
                    v-model="selected"
                    :value="row.item.id_web_service"
                  >
                  </b-form-checkbox>
                </template>
                <template #cell(ftp)="row">
                  <span>{{ row.item.ftp }}</span>
                </template>
                <template #cell(actions)="row">
                  <router-link
                    :to="{
                      name: 'web-service-detail',
                      params: { id: row.item.id_web_service },
                    }"
                    ><b-button class="mr-1 btn-sm mb-1" variant="secondary">
                      <i class="bx bx-show-alt"></i></b-button
                  ></router-link>
                  <b-button
                    class="mr-0 btn-sm mb-1"
                    variant="danger"
                    @click="deleteWebService(row.item.id_web_service)"
                  >
                    <i class="bx bx-trash"></i>
                  </b-button>
                </template>
              </b-table>
              <div v-if="loadingInfo" class="mt-4 mx-auto p-5">
                <div class="text-center">
                  <div
                    class="spinner-border text-secondary"
                    role="status"
                    v-if="loadingInfo"
                  >
                    <span class="sr-only"
                      ><p>{{ $t("website.website-info") }}</p></span
                    >
                  </div>
                </div>
              </div>
            </div>
            <div class="row" v-if="rows > 10 && !loadingInfo">
                  <div class="col-2 col-xl-1">
                      <!-- <div v-if="selected[0]">
                      <b-button class="btn btn-sm" variant="danger" @click="bulkAction()">Bulk Delete : {{selected.length}} Rows Data</b-button>
                      </div> -->
                      <label class="d-inline-flex align-items-center">
                      Page
                      <b-form-input
                          v-model="currentPage"
                          placeholder="Page"
                          class="form-control w-10 form-control ml-2"
                      ></b-form-input>
                      </label>
                  </div>
                  <div class="col-10 col-xl-11 text-right" v-if="rows > 10">
                  <div class="dataTables_paginate paging_simple_numbers float-right">
                      <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
                      </ul>
                  </div>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Vue from "vue";
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import moment from "moment";
import PhoneService from "@/helpers/phone.service.js";
import WebsiteService from "@/helpers/website.service.js";
import SocmedService from "@/helpers/socmed.service.js";
import Swal from "sweetalert2";
import { tableData } from '../../personal/dataAdvancedtable';

export default {
  page: {
    title: "Tools Website",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, PageHeader },
  data() {
    return {
      urlimage: "http://localhost:8001/api/target/image-project?name=",
      loading: false,
      error: "",
      search: false,
      loadingInfo: false,
      searchKey: "",
      SearchResult: "",
      total_results: "",
      tableData: [],
      selected: [],
      selectAll: false,
      is_spam: "",
      title: this.$t("website.website-web-service"),
      items: [
        {
          text: "Dashboard",
          href: "/",
        },
        {
          text: this.$t("website.website-web-service"),
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        { key: "no",  class: 'text-center', thStyle: { width: "2%" }, label:'No'},
        { key: "bulk", thStyle: { width: "2%" }, label: "#" },
        {
          key: "domain_name",
          label: this.$t("website.domain_name"),
          sortable: true,
        },
        { key: "ftp" },
        { key: "ssl" },
        { key: "dns" },
        { key: "smtp" },
        {
          key: "actions",
          class: "text-center",
          thStyle: { width: "12%" },
          label: this.$t("website.actions"),
        },
      ],
    };
  },
  computed: {
    rows() {
      return this.tableData.length;
    },
  },
  methods: {
    select() {
      this.selected = [];
      if (!this.selectAll) {
        for (let i in this.tableData) {
          this.selected.push(this.tableData[i].id_web_service);
        }
      }
    },
    searchWebsite() {
      this.error = "";
      this.loading = true;
      this.search = true;
      this.SearchResult = "";
      const data = {
        website: this.searchKey,
      };
      WebsiteService.searchWebService(data)
        .then((response) => {
          this.SearchResult = response.data.output;
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          if (err.response.status == 500) {
            this.error = this.$t("all.error-500");
          } else if (err.response.status == 404) {
            this.error = this.$t("all.error-404");
          }
        });
    },
    saveWebService() {
      this.loadingsave = true;
      var data = {
        domain_name: this.searchKey,
        ftp: this.SearchResult[0].status,
        ssh: this.SearchResult[1].status,
        telnet: this.SearchResult[2].status,
        smtp: this.SearchResult[3].status,
        whois: this.SearchResult[4].status,
        dns: this.SearchResult[5].status,
        dhcp: this.SearchResult[6].status,
        http: this.SearchResult[7].status,
        pop3: this.SearchResult[8].status,
        sftp: this.SearchResult[9].status,
        nntp: this.SearchResult[10].status,
        ntp: this.SearchResult[11].status,
        netbios: this.SearchResult[12].status,
        imap: this.SearchResult[13].status,
        snmp: this.SearchResult[14].status,
        imap3: this.SearchResult[15].status,
        ldap: this.SearchResult[16].status,
        ssl: this.SearchResult[17].status,
        oracle_sql: this.SearchResult[18].status,
        nfs: this.SearchResult[19].status,
        mysql: this.SearchResult[20].status,
        vnc: this.SearchResult[21].status,
        http2: this.SearchResult[22].status,
      };

      WebsiteService.createWebService(data)
        .then((response) => {
          this.SearchResult = "";
          this.loading = false;
          this.searchKey = "";
          Swal.fire(response.data.message, "", "success");
          this.getWebServiceUpdate();
          this.search = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.search = false;
        });
    },
    getWebService() {
      this.loadingInfo = true;
      WebsiteService.getWebServices()
        .then((response) => {
          let val_data = response.data.data;

          val_data.forEach((val, index) => {
           let data = {
              "no" : index+1,
              "id_web_service": val.id_web_service, 
              "domain_name": val.domain_name, 
              "ftp": val.ftp, 
              "ssh": val.id_web_service, 
              "telnet": val.ssh, 
              "smtp": val.smtp, 
              "whois": val.whois, 
              "dns": val.dns, 
              "dhcp": val.dhcp, 
              "http": val.http, 
              "pop3": val.pop3, 
              "sftp": val.sftp, 
              "nntp": val.nntp, 
              "ntp": val.ntp, 
              "netbios": val.netbios, 
              "imap": val.imap, 
              "snmp": val.snmp, 
              "imap3": val.imap3, 
              "ldap": val.ldap, 
              "ssl": val.ssl, 
              "oracle_sql": val.oracle_sql, 
              "nfs": val.nfs, 
              "mysql": val.mysql, 
              "vnc": val.vnc,
              "http2": val.http2, 
              "created_at": val.created_at, 
              "updated_at": val.updated_at
           }  
           
            this.tableData.push(data);
          });
          this.total_results = response.data.data.length;
          this.loadingInfo = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingInfo = false;
        });
    },
    getWebServiceUpdate() {
      WebsiteService.getWebServices()
        .then((response) => {
          let val_data = response.data.data;

          val_data.forEach((val, index) => {
           let data = {
              "no" : index+1,
              "id_web_service": val.id_web_service, 
              "domain_name": val.domain_name, 
              "ftp": val.ftp, 
              "ssh": val.id_web_service, 
              "telnet": val.ssh, 
              "smtp": val.smtp, 
              "whois": val.whois, 
              "dns": val.dns, 
              "dhcp": val.dhcp, 
              "http": val.http, 
              "pop3": val.pop3, 
              "sftp": val.sftp, 
              "nntp": val.nntp, 
              "ntp": val.ntp, 
              "netbios": val.netbios, 
              "imap": val.imap, 
              "snmp": val.snmp, 
              "imap3": val.imap3, 
              "ldap": val.ldap, 
              "ssl": val.ssl, 
              "oracle_sql": val.oracle_sql, 
              "nfs": val.nfs, 
              "mysql": val.mysql, 
              "vnc": val.vnc,
              "http2": val.http2, 
              "created_at": val.created_at, 
              "updated_at": val.updated_at
           }  
           
            this.tableData.push(data);
          });
          this.total_results = response.data.data.length;
          this.loadingInfo = false;
        })
        .catch((err) => {
          console.log(err);
          this.loadingInfo = false;
        });
    },
    deleteWebService(id) {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          WebsiteService.deleteWebServices(id)
            .then((response) => {
              this.getWebService();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Data Deleted Success",
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    bulkAction() {
      Swal.fire({
        title: this.$t("button.delete.modal.confirmText[0]"),
        text: this.$t("button.delete.modal.confirmText[1]"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        cancelButtonText: this.$t("button.cancel.text"),
        confirmButtonText: this.$t("button.delete.text"),
      }).then((result) => {
        if (result.isConfirmed) {
          var data = this.selected;
          WebsiteService.websiteBulkWebService(data)
            .then((response) => {
              this.selected = [];
              this.getWebService();
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: this.$t("alert.alert-delete-web"),
                showConfirmButton: false,
                timer: 1500,
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    clearData() {
      this.SearchResult = "";
      this.searchKey = "";
      this.search = false;
    },

    formatDate(value) {
      return moment(value).format("dddd, YYYY-MM-DD hh:mm");
    },

    removeHttp(url) {
      let x = url
        .replace(/(^\w+:|^)\/\//, "")
        .replace("/", "")
        .replace("www.", "");
      return (this.searchKey = x);
    },
  },
  mounted() {
    this.totalRows = this.items.length;
    this.getWebService();
  },
};
</script>

<style scoped>
.loading {
  padding-top: 20%;
  padding-bottom: 20%;
}
</style>